import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Address, AddressName } from 'src/app/models/address';
import { ActionType } from 'src/app/models/type/action.type.enum';
import { AddressType } from 'src/app/models/type/address.type.enum';
import { FormValidateComponent } from 'src/app/shared/base-component/form-validate-component';
import { InputAddressComponent } from 'src/app/shared/inputs/input-address/input-address.component';

@Component({
  selector: 'app-input-address-modal',
  templateUrl: './input-address-modal.component.html',
  styleUrls: ['./input-address-modal.component.scss']
})
export class InputAddressModalComponent extends FormValidateComponent implements OnInit, AfterContentInit, AfterViewInit {

  @ViewChild(InputAddressComponent) addressComponent: InputAddressComponent;
  action: ActionType;
  addressList: Array<Address>;
  address: Address = new Address();
  exceptAddressType: Array<AddressType>;
  private addressLabel: AddressName;
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.createForm();
    this.addressLabel = new AddressName();
  }

  ngAfterContentInit(): void {
    this.checkExceptAddressType();
  }

  ngAfterViewInit(): void {
    this.addressComponent.setValueToForm(this.address);
  }

  close() {
    this.hide('close');
  }

  createForm() {
    this.inputForm = this.fb.group({
      'address': this.addressComponent.createForm()
    });
  }

  onSubmit() {
    const data = this.inputForm.get('address').value;
    this.setValidateForm().then((val) => {
      if (this.inputForm.valid) {
        if (data && this.addressLabel) {
          this.address.type = data.addressType as AddressType;
          this.address.address = data.address;
          this.address.subdistrict = data.subdistrict;
          this.address.district = data.district;
          this.address.province = data.province;
          this.address.postalCode = data.postcode;
          this.address.provinceName = this.addressLabel.provinceName ? this.addressLabel.provinceName : this.address.provinceName;
          this.address.districtName = this.addressLabel.districtName ? this.addressLabel.districtName : this.address.districtName;
          this.address.subdistrictName = this.addressLabel.subdistrictName ? this.addressLabel.subdistrictName : this.address.subdistrictName;
          this.address.fullAddress = this.address.address
            + ' ตำบล/แขวง' + this.addressLabel.subdistrictName
            + ' อำเภอ/เขต' + this.addressLabel.districtName
            + ' จังหวัด' + this.addressLabel.provinceName
            + ' ' + this.address.postalCode;
          this.onSave.emit(this.address);
          this.hide(this.action);
        } else if (this.action === ActionType.Edit) {
          this.close();
        }
      } else {
        this.addressComponent.checkValidate();
      }
    });
  }

  setValidateForm() {
    const form = this.inputForm.get('address')
    return new Promise<any>((resolve, reject) => {
      form.get('addressType').setValidators([Validators.required]);
      form.get('addressType').updateValueAndValidity();
      form.get('address').setValidators([Validators.required]);
      form.get('address').updateValueAndValidity();
      form.get('subdistrict').setValidators([Validators.required]);
      form.get('subdistrict').updateValueAndValidity();
      form.get('district').setValidators([Validators.required]);
      form.get('district').updateValueAndValidity();
      form.get('province').setValidators([Validators.required]);
      form.get('province').updateValueAndValidity();
      resolve(true);
    })
  }

  setAddressLabelFromInputAddr(val: Address) {
    // this.addressLabel = val;
    this.addressLabel.provinceName = val.provinceName ? val.provinceName : this.address.provinceName;
    this.addressLabel.districtName = val.districtName ? val.districtName : this.address.districtName;
    this.addressLabel.subdistrictName = val.subdistrictName ? val.subdistrictName : this.address.subdistrictName;
  }

  private hide(msg: string) {
    this.modalService.onHide.emit(msg);
    this.bsModalRef.hide();
  }

  private checkExceptAddressType() {
    if (this.addressList) {
      this.exceptAddressType = this.addressList.map(value => {
        return value.type;
      });
    }
  }

}
